(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-featured-press';
  var ACTIVE_CLASS = 'oddit-section-featured-press__logo-wrapper--active';
  var FADING_CLASS = 'oddit-section-featured-press__quote-text--fading';
  var AUTOPLAY_MS = 5000;
  var FADE_MS = 250;

  function initSection(section) {
    var logos = section.querySelector('.oddit-section-featured-press__logos');
    var buttons = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-featured-press__logo-wrapper')
    );
    var quoteTarget = section.querySelector('[data-press-quote-target]');
    if (!logos || !buttons.length || !quoteTarget) return;

    var current = -1;
    var currentQuote = quoteTarget.innerHTML;
    var timer = null;
    var fadeTimer = null;
    var programmaticScroll = false;
    var programmaticTimer = null;
    var scrollSettleTimer = null;

    // A logo hidden by a responsive `display: none` should be skipped by
    // autoplay (e.g. the 4th logo on mobile widths).
    function isVisible(btn) {
      return btn.offsetParent !== null;
    }

    function isScrollable() {
      return logos.scrollWidth - logos.clientWidth > 1;
    }

    function centerButton(btn) {
      if (!isScrollable()) return;
      var cRect = logos.getBoundingClientRect();
      var bRect = btn.getBoundingClientRect();
      var delta = (bRect.left - cRect.left) - (logos.clientWidth - bRect.width) / 2;
      programmaticScroll = true;
      if (programmaticTimer) window.clearTimeout(programmaticTimer);
      programmaticTimer = window.setTimeout(function () {
        programmaticScroll = false;
      }, 600);
      logos.scrollTo({ left: logos.scrollLeft + delta, behavior: 'smooth' });
    }

    function setActive(index, scroll) {
      var btn = buttons[index];
      if (!btn) return;

      if (index !== current) {
        current = index;
        for (var i = 0; i < buttons.length; i++) {
          var on = i === index;
          buttons[i].classList.toggle(ACTIVE_CLASS, on);
          buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }

        var quote = btn.getAttribute('data-press-quote');
        if (quote != null && quote !== currentQuote) {
          currentQuote = quote;
          if (fadeTimer) window.clearTimeout(fadeTimer);
          quoteTarget.classList.add(FADING_CLASS);
          fadeTimer = window.setTimeout(function () {
            quoteTarget.innerHTML = quote;
            quoteTarget.classList.remove(FADING_CLASS);
          }, FADE_MS);
        }
      }

      if (scroll) centerButton(btn);
    }

    function nextIndex() {
      var n = buttons.length;
      for (var step = 1; step <= n; step++) {
        var idx = (current + step) % n;
        if (isVisible(buttons[idx])) return idx;
      }
      return current;
    }

    function advance() {
      setActive(nextIndex(), true);
    }

    // Closest visible logo to the centre of the scroll viewport.
    function nearestToCenter() {
      var center = logos.getBoundingClientRect().left + logos.clientWidth / 2;
      var best = current;
      var bestDist = Infinity;
      for (var i = 0; i < buttons.length; i++) {
        if (!isVisible(buttons[i])) continue;
        var r = buttons[i].getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function startAutoplay() {
      stopAutoplay();
      timer = window.setInterval(advance, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        setActive(i, true);
        startAutoplay(); // user interaction resets the 5s timer
      });
    });

    // Manual swipe: once scrolling settles, adopt the centred logo.
    logos.addEventListener('scroll', function () {
      if (programmaticScroll) return;
      if (scrollSettleTimer) window.clearTimeout(scrollSettleTimer);
      scrollSettleTimer = window.setTimeout(function () {
        setActive(nearestToCenter(), false);
      }, 120);
    }, { passive: true });

    // Pause autoplay while the user is interacting.
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);
    logos.addEventListener('touchstart', stopAutoplay, { passive: true });
    logos.addEventListener('touchend', startAutoplay, { passive: true });

    // Start on the first visible logo.
    var startIdx = 0;
    for (var j = 0; j < buttons.length; j++) {
      if (isVisible(buttons[j])) {
        startIdx = j;
        break;
      }
    }
    setActive(startIdx, true);
    startAutoplay();
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
